/* eslint-disable react/jsx-filename-extension */
import React from 'react'

import { wrapRootElement } from './src/components/common/wrap-root-element'
import { Layout } from './src/components/layout'

const wrapPageElement = ({ element }) => <Layout>{element}</Layout>

export { wrapPageElement, wrapRootElement }
